import React, { useState } from "react";
import { ReactComponent as IconPlus } from "../../../layout/others/icon_plus.svg";
import { InterviewService } from "../../../services/InterviewService";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ModalAlertToCloneInterview from "../ModalAlertToCloneInterview";
import ConversationIcon from "../../../layout/left_menu_icons/conversation.svg";
import ScreenCallIcon from "../../../layout/other_icons/ScreenCall_icon.svg";
import "../../Interview/Interview.scss";
import "../../styles/header.scss";
import { ReactComponent as IconExclamation } from "../../../layout/others/icon_alert_exclamation.svg";
import SelectedTag from "../../../components/Tags/SelectedTag";

const InterviewPreviewHeader = ({ children, interview, userInformation }) => {
  const { t } = useTranslation();
  const history = useHistory();
  //const INTERVIEW = 1;
  const [showModalCloneInterview, setShowModalCloneInterview] = useState(false);

  function refreshInterviewList() {
    if (window.opener)
      window.opener.postMessage("INTERVIEWLISTREFRESH", window.location.origin);
  }

  function onClickNewInterview() {
    setShowModalCloneInterview(false);
    InterviewService.cloneLastInterview(interview.interviewId).then(
      (interviewClone) => {
        if (!interviewClone.error) {
          refreshInterviewList();
          history.push(`/interview/createoredit/${interviewClone.interviewId}`);
        }
      }
    );
  }
  function GetHeaderTitle() {
    if (interview.typeOfInterview === 1) {
      return `${t("Interview - Nº")} ${interview.interviewOrderSequence} / ${
        interview.totalInterviews
      } ${
        interview.personalInformation.fullName &&
        ` - ${interview.personalInformation.fullName} - `
      }(${t("Created on")} ${` :`} ${interview.createdDate})`;
    } else if (interview.typeOfInterview === 2) {
      return `${t("Screen Call")}  ${
        interview.personalInformation.fullName &&
        ` - ${interview.personalInformation.fullName} - `
      }(${t("Created on")} ${` :`} ${interview.createdDate})`;
    }
  }

  return (
    <>
      <header className="page-header">
        <div className="header-title">
          <div className="title">
            {" "}
            {interview.typeOfInterview === 1 ? (
              <img src={ConversationIcon} alt="ni-icon" />
            ) : (
              <img src={ScreenCallIcon} alt="ni-icon" />
            )}
            <h1 style={{ marginTop: "10px" }}>
              {GetHeaderTitle()}

              {!interview.isFinalized && (
                <IconExclamation
                  className="icon-exclamation-size"
                  title={t("Incomplete Interview")}
                />
              )}
            </h1>
          </div>
          <h4 className="fw-bold">{interview.formerCompany}</h4>
          <SelectedTag interviewTag={interview.tags} />
          <div className="subtitle">{t("Recruitment / Interviews")}</div>
        </div>
        {children ? (
          children
        ) : (
          <div className="text-end col-auto">
            {userInformation.permissions.Create_Edit_Interview &&
              interview.isActive &&
              interview.isHired === false && (
                <a
                  href="#!"
                  className="btn app-button btn-second btn-lg"
                  onClick={() =>
                    history.push(
                      `/interview/createOrEdit/${interview.interviewId}`
                    )
                  }
                >
                  {t("Edit")}
                </a>
              )}
            {interview.isFinalized &&
              interview.isActive &&
              userInformation.permissions.Create_Edit_Interview &&
              interview.isHired === false && (
                <button
                  type="button"
                  className="app-button btn-prime btn-lg"
                  onClick={() => {
                    setShowModalCloneInterview(true);
                  }}
                >
                  <IconPlus /> {t("Interview")}
                </button>
              )}
          </div>
        )}

        <ModalAlertToCloneInterview
          showModal={showModalCloneInterview}
          setShowModal={setShowModalCloneInterview}
          submitButtonAction={onClickNewInterview}
        />
      </header>{" "}
    </>
  );
};

export default InterviewPreviewHeader;
